import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'
import constructRequestData from '../../constructRequestData'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Profile.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

const clientApi = new APIClient({
  baseURL: process.env.REACT_APP_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /user/profiles': 200,
    // 'patch /user/profiles': 200,
    // 'post /user/profiles/otp': 200,
    // 'get /user/activity/searches': 200,
    // 'get /user/account-status': 200,
    // 'post /user/activity/searches': 200,
    // 'delete /user/activity/searches': 200,
    // 'get /user/referral-code': 200,
    // 'post /user/password-request': 200,
    // 'post /user/password-otp': 200,
    // 'patch /user/password': 200,
    // 'get /user/favorites/malls': 200,
    // 'post /user/favorites/malls': 200,
    // 'post /email/verification/request': 200,
    // 'get /email/verification': 200,
  })
}

export const getProfile = accessToken =>
  client({
    method: 'get',
    url: '/user/profiles',
    data: {},
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getUserAvatar = accessToken =>
  client({
    method: 'get',
    url: '/user/avatar',
    data: {},
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
      'Content-type': '',
    },
    responseType: 'blob',
  })

export const updateProfile = (profileData, accessToken) => {
  const { firstName, lastName, email, mobileNumber } = profileData

  return client({
    method: 'patch',
    url: '/user/profiles',
    data: {
      firstName,
      lastName,
      email,
      mobileNumber,
      clientId: process.env.REACT_APP_CLIENT_ID,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}

export const postUpdateProfileOtpResend = requestId =>
  client.post(
    '/resend',
    constructRequestData({
      requestId,
      type: 0,
    }),
  )

export const getUserRecentSearches = accessToken =>
  client({
    method: 'get',
    url: '/user/activity/searches?limit=5',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getAccountStatus = accessToken =>
  client({
    method: 'get',
    url: '/user/account-status',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const getReferralCode = accessToken =>
  client({
    method: 'get',
    url: '/user/referral-code',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const changePasswordOtpResend = requestId => {
  return client.post(
    '/resend',
    constructRequestData({
      requestId,
      type: 1,
    }),
  )
}

export const getAllFavoriteMalls = accessToken =>
  client({
    method: 'get',
    url: '/user/favorites/malls',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const postFavoriteMall = (id, accessToken) =>
  client({
    method: 'post',
    url: '/user/favorites/malls',
    data: {
      id,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const postEmailVerification = accessToken =>
  client({
    method: 'post',
    url: '/email/verification/request',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const getEmailVerification = accessToken =>
  client({
    method: 'get',
    url: '/email/verification',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

//SOFT DELETE UNUSED API
export const getEmailVerificationWithToken = urlToken =>
  client({
    method: 'get',
    url: `/email/verification/${encodeURIComponent(urlToken)}`,
    data: {
      token: urlToken,
    },
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })

export const postFeedback = (accessToken, feedback) =>
  client({
    method: 'post',
    url: '/user/feedbacks',
    data: feedback,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const postLoungePass = accessToken =>
  client({
    method: 'post',
    url: '/lounge-pass/claim',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const postMissingDetails = (accessToken, details) =>
  client({
    method: 'post',
    url: '/user/profiles/missing-details',
    data: constructRequestData(details),
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const getUserSettings = accessToken =>
  client({
    method: 'get',
    url: '/user-settings',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const postUserSettings = (accessToken, userSettings) =>
  client({
    method: 'put',
    url: '/user-settings',
    data: userSettings,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
